const topics = [
  { tag: '#剑尊归来', heat: '9.8w', hot: true },
  { tag: '#我独自升级', heat: '8.5w', hot: true },
  { tag: '#斗破苍穹', heat: '9.1w', hot: true },
  { tag: '#女神降临', heat: '7.2w', hot: false },
  { tag: '#暗黑之城', heat: '6.8w', hot: true },
  { tag: '#全职猎人', heat: '8.0w', hot: false },
  { tag: '#韩漫推荐', heat: '7.5w', hot: true },
  { tag: '#国漫崛起', heat: '6.3w', hot: true },
  { tag: '#日漫经典', heat: '5.9w', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full bg-background-50 py-14 md:py-20">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">
            热门话题
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-[480px] mx-auto">
            妖精动漫社区当前最热讨论话题，看看大家都在追什么
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 max-w-[900px] mx-auto">
          {topics.map((t, i) => (
            <a
              key={i}
              href={`#topics`}
              onClick={(e) => e.preventDefault()}
              className="group inline-flex items-center gap-2 bg-background-50 border border-background-200/70 rounded-full px-4 py-2.5 cursor-pointer hover:border-accent-300 hover:bg-accent-50/50 transition-all duration-200"
            >
              <span className="text-sm font-medium text-foreground-700 group-hover:text-accent-600">
                {t.tag}
              </span>
              <span className="flex items-center gap-1 text-xs text-accent-500 font-semibold">
                {t.hot && <i className="ri-fire-line text-xs text-primary-400"></i>}
                {t.heat}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}